import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { INormalizedPayload } from '@core/state/entities/entity';
import { EmailTemplatesKey } from '@core/state/entities/entity-name-map';
import { IErrorState } from '@core/actions/project-detail.actions';
import {IEmailTemplate} from '@core/state/entities/email-templates/email-template.entity';

export const adminActions = createActionGroup({
  source: 'Admin',
  events: {
    'load email templates': emptyProps(),
    'email templates loaded': props<INormalizedPayload<EmailTemplatesKey>>(),
    'email templates load failed': props<IErrorState>(),
    'update email template': props<{
      templateName: string;
      template: IEmailTemplate;
    }>(),
    'email template updated': props<INormalizedPayload<EmailTemplatesKey>>(),
    'email template update failed': props<IErrorState>(),
    'create email template': props<
      {
        templateName: string;
        template: IEmailTemplate;
      }>(),
    'email template created': props<INormalizedPayload<EmailTemplatesKey>>(),
    'email template create failed': props<IErrorState>(),
    'delete email template': props<{ templateName: string }>(),
    'email template deleted': props<{id: string}>(),
    'email template delete failed': props<IErrorState>(),
    'toggle admin ui options': emptyProps(),
    /**
     * The backend's capability decisions for presentation (M2a), or null where PM authority does
     * not decide them here (off/shadow, not yet read, or the read failed): the claim fallback.
     */
    'application capabilities presented': props<{
      capabilities: Readonly<Record<string, boolean>> | null;
    }>(),
  },
});
